import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=2c5e6086&scoped=true&"
import script from "./editGoods.vue?vue&type=script&lang=js&"
export * from "./editGoods.vue?vue&type=script&lang=js&"
import style0 from "./editGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editGoods.vue?vue&type=style&index=1&id=2c5e6086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e6086",
  null
  
)

component.options.__file = "editGoods.vue"
export default component.exports